import { Controller } from "@hotwired/stimulus"

// Light UI sugar around a JSON textarea that holds a hash of
// { TaskClassName: priorityInteger }. The textarea is the source of truth on submit;
// the Add/Remove controls just rewrite it.
export default class extends Controller {
  static targets = ["json", "rowsContainer", "taskClass", "priority"]

  parseJson() {
    const raw = this.jsonTarget.value.trim()
    if (raw === "") return {}
    try {
      const parsed = JSON.parse(raw)
      return (parsed && typeof parsed === "object" && !Array.isArray(parsed)) ? parsed : {}
    } catch (_e) {
      return null
    }
  }

  writeJson(obj) {
    this.jsonTarget.value = JSON.stringify(obj)
  }

  addRow(e) {
    e.preventDefault()
    const taskClass = this.taskClassTarget.value
    const priorityRaw = this.priorityTarget.value
    if (!taskClass || priorityRaw === "") return
    const priority = parseInt(priorityRaw, 10)
    if (Number.isNaN(priority)) return

    const obj = this.parseJson()
    if (obj === null) {
      window.alert("Cannot add row: the raw JSON is invalid. Fix or clear it first.")
      return
    }
    obj[taskClass] = priority
    this.writeJson(obj)
    this.priorityTarget.value = ""
    this.renderRows()
  }

  removeRow(e) {
    e.preventDefault()
    const taskClass = e.currentTarget.dataset.taskClass
    const obj = this.parseJson()
    if (obj === null) return
    delete obj[taskClass]
    this.writeJson(obj)
    this.renderRows()
  }

  renderRows() {
    const obj = this.parseJson()
    const container = this.rowsContainerTarget
    container.innerHTML = ""

    if (obj === null) {
      const div = document.createElement("div")
      div.className = "text-sm text-alert-red-700 italic"
      div.textContent = "Invalid JSON — fix the raw JSON below."
      container.appendChild(div)
      return
    }

    const keys = Object.keys(obj)
    if (keys.length === 0) {
      const div = document.createElement("div")
      div.className = "text-sm text-support-dark-600 italic"
      div.textContent = "No overrides set."
      container.appendChild(div)
      return
    }

    keys.sort().forEach((taskClass) => {
      const row = document.createElement("div")
      row.className = "flex items-center gap-2 text-sm"
      row.dataset.taskClass = taskClass

      const name = document.createElement("code")
      name.className = "flex-1"
      name.textContent = taskClass
      row.appendChild(name)

      const eq = document.createElement("span")
      eq.textContent = "="
      row.appendChild(eq)

      const value = document.createElement("code")
      value.textContent = obj[taskClass]
      row.appendChild(value)

      const removeBtn = document.createElement("button")
      removeBtn.type = "button"
      removeBtn.className = "text-alert-red-700 text-xs ml-2"
      removeBtn.textContent = "remove"
      removeBtn.dataset.action = "click->task-priority-overrides#removeRow"
      removeBtn.dataset.taskClass = taskClass
      row.appendChild(removeBtn)

      container.appendChild(row)
    })
  }
}
